import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { presetDecorator, RemirrorManager, getLazyArray, Preset } from '@remirror/core';
import { DocExtension } from '@remirror/extension-doc';
import { EventsExtension } from '@remirror/extension-events';
import { GapCursorExtension } from '@remirror/extension-gap-cursor';
import { HistoryExtension } from '@remirror/extension-history';
import { ParagraphExtension } from '@remirror/extension-paragraph';
import { PositionerExtension } from '@remirror/extension-positioner';
import { TextExtension } from '@remirror/extension-text';

var _dec, _class, _temp;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * The options for the core preset.
 */

var CorePreset = (_dec = /*#__PURE__*/presetDecorator({
  defaultOptions: /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread({}, DocExtension.defaultOptions), ParagraphExtension.defaultOptions), HistoryExtension.defaultOptions), {}, {
    excludeExtensions: []
  }),
  customHandlerKeys: ['positioner'],
  handlerKeys: ['onRedo', 'onUndo'],
  staticKeys: ['content', 'depth', 'newGroupDelay', 'excludeExtensions']
}), /*#__PURE__*/_dec(_class = (_temp = class CorePreset extends Preset {
  constructor() {
    super(...arguments);

    _defineProperty(this, "onAddCustomHandler", handlers => {
      var positioner = handlers.positioner;

      if (positioner) {
        return this.getExtension(PositionerExtension).addCustomHandler('positioner', positioner);
      }

      return;
    });
  }

  get name() {
    return 'core';
  }
  /**
   * No properties are defined so this can be ignored.
   */


  onSetOptions(_) {}

  createExtensions() {
    var _this$options = this.options,
        content = _this$options.content,
        depth = _this$options.depth,
        getDispatch = _this$options.getDispatch,
        getState = _this$options.getState,
        newGroupDelay = _this$options.newGroupDelay,
        excludeExtensions = _this$options.excludeExtensions;
    var excludeMap = {};

    var _iterator = _createForOfIteratorHelper(excludeExtensions !== null && excludeExtensions !== void 0 ? excludeExtensions : []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        excludeMap[name] = true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var coreExtensions = [];

    if (!excludeMap['history']) {
      var historyExtension = new HistoryExtension({
        depth,
        getDispatch,
        getState,
        newGroupDelay
      });
      historyExtension.addHandler('onRedo', this.options.onRedo);
      historyExtension.addHandler('onUndo', this.options.onUndo);
      coreExtensions.push(historyExtension);
    }

    if (!excludeMap['doc']) {
      coreExtensions.push(new DocExtension({
        content
      }));
    }

    if (!excludeMap['text']) {
      coreExtensions.push(new TextExtension());
    }

    if (!excludeMap['paragraph']) {
      coreExtensions.push(new ParagraphExtension());
    }

    if (!excludeMap['positioner']) {
      coreExtensions.push(new PositionerExtension());
    }

    if (!excludeMap['gapCursor']) {
      coreExtensions.push(new GapCursorExtension());
    }

    if (!excludeMap['events']) {
      coreExtensions.push(new EventsExtension());
    }

    return coreExtensions;
  }

}, _temp)) || _class);

/**
 * Create a manager with the core preset already applied.
 */
function createCoreManager(combined) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var core = options.core,
      managerSettings = _objectWithoutProperties(options, ["core"]);

  return RemirrorManager.create(() => [...getLazyArray(combined), new CorePreset(core)], managerSettings);
}

export { CorePreset, createCoreManager };
